import { NavLink } from "react-router-dom";

const linkClass = ({ isActive }) =>
  `text-sm font-medium tracking-wide transition-colors hover:text-[#1E3A6E] ${isActive ? "text-[#1E3A6E]" : "text-zinc-600"}`;

export function NavLinks({ links }) {
  return (
    <nav className="hidden xl:flex items-center gap-6">
      {links.map((l) => (
        <NavLink key={l.to} to={l.to} className={linkClass} data-testid={l.testId}>
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}
